<section class="p-grid">
  <div class="p-col-12">
    <h1>Failed Sensor Replacement</h1>
  </div>
</section>
<form [formGroup]="editForm" novalidate class="p-grid mobile">
  <div class="p-sm-5">
    <label for="pod_serial_number">Pod Serial Number</label>
  </div>
  <div class="p-sm-7">
    <input formControlName="pod_serial_number" type="text" [ngModel]="sensorFailure.pod_serial_number" pInputText
      disabled />
  </div>
  <div class="p-sm-5">
    <label for="sensor_serial_number">Sensor Serial Number</label>
  </div>
  <div class="p-sm-7">
    <input formControlName="sensor_serial_number" type="text" [(ngModel)]="sensorFailure.sensor_serial_number"
      pInputText disabled />
  </div>
  <div class="p-sm-5">
    <label for="sensor_type">Sensor Type</label>
  </div>
  <div class="p-sm-7">
    <input formControlName="sensor_type" type="text" [(ngModel)]="sensorFailure.sensor_type" pInputText disabled />
  </div>
  <div class="p-sm-5">
    <label for="replacement_sensor_serial">Replacement Sensor Serial</label>
  </div>
  <div class="p-sm-7">
    <input formControlName="replacement_sensor_serial" type="text" [(ngModel)]="sensorFailure.replacement_sensor_serial"
      pInputText disabled />
  </div>
  <div class="p-sm-5">
    <label for="notes">Notes</label>
  </div>
  <div class="p-sm-7">
    <textarea name="notes" id="notes" style="height:100px;" pInputTextarea [(ngModel)]="sensorFailure.notes"
      [ngModelOptions]="{standalone: true}"></textarea>
  </div>
  <div class="p-col-12 p-grid">
    <div class="p-col-12">
      <p><strong>IMPORTANT</strong> - do <strong>NOT</strong> indicate that a sensor is replaced until AFTER the sensor has been
        physically replaced." then leave a line before the buttons.</p>
    </div>
    <div class="p-col-5">
      <button label="Sensor Replaced" type="button" class="p-button-raised  p-button-primary" pButton
        (click)="sensorReplaced()" positionStyle="fixed"
        pTooltip="IMPORTANT Do NOT click this button until AFTER the sensor has ACTUALLY been replaced!!"
        style="width: 100%"></button>
    </div>
    <div class="p-col-4">
      <button label="Exit" type="button" class="p-button-raised p-button-danger" pButton (click)="cancel()"
        positionStyle="fixed" pTooltip="Log out." style="width: 100%"></button>
    </div>
  </div>
</form>
<form [formGroup]="editForm" novalidate class="p-grid desktop">
  <div class="p-sm-12 p-md-6 p-grid">
    <label for="pod_serial_number">Pod Serial Number</label>
    <input formControlName="pod_serial_number" type="text" [ngModel]="sensorFailure.pod_serial_number" pInputText
      disabled />
  </div>
  <div class="p-sm-12 p-md-6">
    <label for="sensor_serial_number">Sensor Serial Number</label>
    <input formControlName="sensor_serial_number" type="text" [(ngModel)]="sensorFailure.sensor_serial_number"
      pInputText disabled />
  </div>
  <div class="p-sm-12">
    <label for="sensor_type">Sensor Type</label>
    <input formControlName="sensor_type" type="text" [(ngModel)]="sensorFailure.sensor_type" pInputText disabled />
  </div>
  <div class="p-col-12">
    <label for="replacement_sensor_serial">Replacement Sensor Serial</label>
    <input formControlName="replacement_sensor_serial" type="text" [(ngModel)]="sensorFailure.replacement_sensor_serial"
      pInputText disabled />
  </div>
  <div class="p-col-8">
    <label for="notes">Notes</label> <br />
    <p-scrollPanel [style]="{width: '100%', height: '100px'}">
      <textarea name="notes" id="notes" style="height:100px;" pInputTextarea [(ngModel)]="sensorFailure.notes"
        [ngModelOptions]="{standalone: true}"></textarea>
    </p-scrollPanel>
  </div>
  <div class="p-col-12">
    <p><strong>IMPORTANT</strong> - do <strong>NOT</strong> indicate that a sensor is replaced until AFTER the sensor has been physically
      replaced." then leave a line before the buttons.</p>
  </div>
  <div class="p-col-12 p-grid">
    <div class="p-col-2">
      <button label="Sensor Replaced" type="button" class="p-button-raised  p-button-primary" pButton
        (click)="sensorReplaced()" positionStyle="fixed"
        pTooltip="IMPORTANT Do NOT click this button until AFTER the sensor has ACTUALLY been replaced!!"></button>
    </div>
    <div class="p-col-4">
      <button label="Exit" type="button" class="p-button-raised p-button-danger" pButton (click)="cancel()"
        positionStyle="fixed" pTooltip="Log out."></button>
    </div>
  </div>
</form>
<p-confirmDialog header="Confirmation" width="300"></p-confirmDialog>
